import cx from "classnames";
import React from "react";

import { useProgramColorPicker } from "../../helpers/useProgramColorPicker";
import * as styles from "./TextLink.module.css";

type TextLinkProps = Readonly<{
  children: string;
  href: string;
  className?: string;
}>;

export const TextLink = ({ children, className, href }: TextLinkProps) => {
  const colorStyle = useProgramColorPicker();
  return (
    <div className={className}>
      <a
        className={cx(styles.basicLinkButton, colorStyle)}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={0}
      >
        {children}
      </a>
    </div>
  );
};
